import type { SvgIconComponent } from '@mui/icons-material';
import {
  DEFAULT_APPOINTMENT_TYPE_LABELS,
  BuiltinAppointmentTypeOverride,
  CustomAppointmentType,
  getAppointmentTypeColor,
  getAppointmentTypeOptions,
  isCommitmentAppointmentType,
  isFisioterapiaClinic,
} from '../constants/appointmentTypes';
import { resolveAppointmentTypeIconComponent } from './appointmentTypeIcons';
import { EventBusy as CommitmentIconMui } from '@mui/icons-material';

export type AgendaAppointmentTypeDef = {
  label: string;
  color: string;
  Icon: SvgIconComponent;
  iconId?: string;
};

export function buildAgendaAppointmentTypes(
  specialty: string | null,
  custom: CustomAppointmentType[],
  overrides: Record<string, BuiltinAppointmentTypeOverride> = {},
): Record<string, AgendaAppointmentTypeDef> {
  const out: Record<string, AgendaAppointmentTypeDef> = {};
  for (const opt of getAppointmentTypeOptions(specialty, custom)) {
    const isCommitment = isCommitmentAppointmentType(opt.value);
    const customRow = custom.find((t) => t.key === opt.value);
    const override = overrides[opt.value];
    const label = customRow?.label || override?.label || opt.label;
    const color = customRow?.color || override?.color || getAppointmentTypeColor(opt.value, specialty);
    const iconId = customRow?.icon || override?.icon;
    const Icon = isCommitment
      ? CommitmentIconMui
      : resolveAppointmentTypeIconComponent(opt.value, iconId);
    out[opt.value] = { label, color, Icon, iconId };
  }
  if (isFisioterapiaClinic(specialty)) {
    for (const [key, defaultLabel] of Object.entries(DEFAULT_APPOINTMENT_TYPE_LABELS)) {
      if (!out[key]) {
        const override = overrides[key];
        out[key] = {
          label: override?.label || defaultLabel,
          color: override?.color || getAppointmentTypeColor(key, specialty),
          Icon: resolveAppointmentTypeIconComponent(key, override?.icon),
          iconId: override?.icon,
        };
      }
    }
  }
  return out;
}
